import { render, staticRenderFns } from "./ExtratoConsignacao.vue?vue&type=template&id=0d6426a0&scoped=true&"
import script from "./ExtratoConsignacao.vue?vue&type=script&lang=js&"
export * from "./ExtratoConsignacao.vue?vue&type=script&lang=js&"
import style0 from "./ExtratoConsignacao.vue?vue&type=style&index=0&id=0d6426a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6426a0",
  null
  
)

export default component.exports